import { genericPostingActionCreator, getCookieValue } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'
import { fetchAssignmentNotes } from './fetchAssignmentNotesAction'

export const clearMessages = () => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator('POST_ASSIGNMENT_NOTES', 'init'))
  }
}

export const postAssignmentNote = (propertyAppraisalId, data, lin) => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator('POST_ASSIGNMENT_NOTES', 'posting'))
    fetch(`/lgyhub/api/appraiser-workspace/property-appraisal/${propertyAppraisalId}/notes`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        noteAccessIndicator: data.accessIndicator ? 'External' : 'Internal',
        noteTypeCode: data.noteType,
        noteText: data.noteText
      }),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'uploading your note')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        throw new Error(responseJson.errors[0].message)
      } else {
        dispatch(genericPostingActionCreator('POST_ASSIGNMENT_NOTES', 'posted', responseJson))
        dispatch(fetchAssignmentNotes(propertyAppraisalId, lin))
      }
    }).catch((error) => {
      dispatch(genericPostingActionCreator('POST_ASSIGNMENT_NOTES', 'error'))
      console.error('Appraisal Notes posting error: ', error)
    })
  }
}
